<template>
    <div  class="card shadow"
         :class="type === 'dark' ? 'bg-default': ''">
        <div class="card-header border-0"
             :class="type === 'dark' ? 'bg-transparent': ''">
            <div class="row align-items-center">
                <div class="col form-inline">
                    <select  v-model="socialconcept"
                            v-bind:readonly="isLoading"
                            @change="changeSocialconcept(socialconcept)"
                            class="custom-select form-control form-control-alternative mr-1 "
                    >
                        <option selected :value="null">Sozialkonzept auswählen oder anlegen</option>
                        <option v-for="sc in socialconceptList" :key="sc.name+sc.id" :value="sc.id">{{ sc.name }}
                        </option>
                    </select>
                    <base-button v-if="socialconcept !== null" :disabled="isLoading" type="secondary" @click="() => { showEditSocialConcept = !showEditSocialConcept; showAddSocialConcept = false; editSocialConcept  = socialconceptList.find(obj => obj.id === socialconcept);}" icon="ni ni-settings" alt="Sozialkonzept ändern"></base-button>
                    <base-button v-else type="secondary" :disabled="isLoading" @click="() => { showAddSocialConcept = !showAddSocialConcept, showEditSocialConcept = false; }" icon="ni ni-fat-add" alt="Neues Sozialkonzept anlegen"></base-button>
                    <h4 v-if="showAddSocialConcept" class="mt-2">Neues Sozialkonzept hinzufügen</h4>
                    <div v-if="showAddSocialConcept" class="form-inline">
                        <base-input v-model="newSocialConcept.name" aria-placeholder="Bezeichnung" :disabled="isLoading" class="mr-1" input-classes="form-control form-control-alternative"></base-input>
                        <base-button type="secondary" @click="addSocialConceptFunction(newSocialConcept)" :disabled="isLoading" icon="ni ni-send" alt="Neues Sozialkonzept anlegen"></base-button>
                    </div>
                    <h4 v-if="showEditSocialConcept" class="mt-2">Bestehendes Sozialkonzept ändern</h4><br>
                    <div v-if="showEditSocialConcept" class="form-inline">
                        <base-input v-model="editSocialConcept.name" aria-placeholder="Bezeichnung" :disabled="isLoading" class="mr-1" input-classes="form-control form-control-alternative"></base-input>
                        <base-button type="secondary" @click="editSocialConceptFunction(editSocialConcept)" :disabled="isLoading" icon="ni ni-send" alt="Bestehendes Sozialkonzept ändern"></base-button>
                    </div>
                </div>
                <div v-if="socialconcept !== null"  class="col text-right">
                    <base-button size="sm" type="secondary" @click="changeSocialconcept(socialconcept)" icon="fas fa-sync-alt"></base-button>
                    <create-action :socialconcept="'/api/socialconcepts/'+socialconcept" @actionCreated="changeSocialconcept(socialconcept)"></create-action>
                </div>
            </div>
        </div>
        <!---<div v-if="$store.getters['profiles/showProfiles'].length > 0 && !$store.getters['profiles/isLoading'] && typeof $store.getters['profiles/showProfiles'][0].id !== 'undefined'" class="table-responsive">--->
        <div class="table-responsive">
            <base-table class="table align-items-center table-flush"
                        :class="type === 'dark' ? 'table-dark': ''"
                        :thead-classes="type === 'dark' ? 'thead-dark': 'thead-light'"
                        tbody-classes="list"
                        :data="tableData">
                <template slot="columns">
                    <th>id</th>
                    <th>Interner Name</th>
                    <th>Öffentlicher name</th>
                    <th>Kategorie</th>
                    <th>Eventgesteuert</th>
                    <th>Öffentlich</th>
                    <th></th>
                </template>

                <template slot-scope="{row}">
                    <th v-on:dblclick="editable.push(row.id)" scope="row">
                        <div v-if="isLoadingData" class="loading"> </div><div v-else>{{row.id}}</div>
                    </th>
                    <td v-on:dblclick="editable.push(row.id)" style="white-space: normal !important;">
                        <div v-if="isLoadingData" class="loading"> </div><div v-else><span v-if="!editable.includes(row.id) || isLoading">{{row.name}}</span>
                        <base-input v-else v-model="row.name" class="form-no-padding" input-classes="form-no-padding"></base-input></div>
                    </td>
                    <td v-on:dblclick="editable.push(row.id)" style="white-space: normal !important;">
                        <div v-if="isLoadingData" class="loading"> </div><div v-else><span v-if="!editable.includes(row.id) || isLoading">{{row.publicName}}</span>
                        <base-input v-else v-model="row.publicName" class="form-no-padding" input-classes="form-no-padding"></base-input></div>
                    </td>
                    <td v-on:dblclick="editable.push(row.id)" style="white-space: normal !important;">
                        <div v-if="isLoadingData" class="loading"> </div><div v-else><span v-if="!editable.includes(row.id) || isLoading">{{row.category}}</span>
                        <base-input v-else v-model="row.category" class="form-no-padding" input-classes="form-no-padding"></base-input></div>
                    </td>
                    <td v-on:dblclick="editable.push(row.id)">
                        <div v-if="isLoadingData" class="loading"> </div><div v-else><switches v-model="row.isSetAuto"
                                                                                               :disabled="!editable.includes(row.id) || isLoading"
                                                                                               theme="bootstrap"
                                                                                               color="primary"
                                                                                               style="padding-left: 2rem;"
                                                                                               text-enabled="auto"
                                                                                               text-disabled="manuel"></switches></div>
                    </td>
                    <td v-on:dblclick="editable.push(row.id)">
                        <div v-if="isLoadingData" class="loading"> </div><div v-else><switches v-model="row.isPublic"
                                                                                               :disabled="!editable.includes(row.id) || isLoading"
                                                                                               theme="bootstrap"
                                                                                               color="primary"
                                                                                               style="padding-left: 2rem;"
                                                                                               text-enabled="öffentlich"
                                                                                               text-disabled="intern"></switches></div>
                    </td>
                    <td class="text-right">
                        <div v-if="isLoadingData" class="loading-button"> </div><div v-else><template>
                            <base-button v-if="!editable.includes(row.id)" v-on:click="editable.push(row.id)" icon="fas fa-pencil-alt" type="secondary" icon-only
                                         title="Quickedit"></base-button>
                            <div v-else>
                                <base-button v-on:click="editable.splice(editable.indexOf(row.id),1)" v-if="!isLoading" icon="fa fa-ban" type="secondary" icon-only
                                                                           title="abbrechen"></base-button>
                                <base-button v-on:click="editAction(row)" :disabled="isLoading" :icon="(isLoading) ? 'fas fa-circle-notch fa-spin' : 'fas fa-save'" type="primary" icon-only
                                                                            title="speichern"></base-button></div>
                        </template></div>
                    </td>
                </template>
            </base-table>
        </div>
    </div>
</template>

<script>

    import Switches from "vue-switches";
    import CreateAction from "@/views/Socialconcepts/createActionForm";
    export default {
        name: "editStatesTable",
        components:{CreateAction, Switches},
        props: {
            type: {
                type: String
            },
            title: String
        },
        data() {
            return {
                editable: [],
                socialconcept: null,
                newSocialConcept: {name:''},
                editSocialConcept: {name:''},
                showAddSocialConcept: false,
                showEditSocialConcept: false,
                socialconceptList: [{
                    id: 0,
                    name: 'kein Sozialkonzept hinterlegt'
                }],
                tableData:[
                    {
                        id:0,
                        name: "Keine Daten",
                        publicName: '',
                        category: '',
                        isSetAuto: false,
                        isPublic: null,
                        socialconcept: null
                    }
                ],
                periodeOptions: [{value: 'previous', text: 'Vorherige'},{value: 'deadline', text: 'Deadline'}],
                totalitems:0,
                isLoading: false
            }
        },
        created() {
            this.loadSocialConcepts();
            this.changeSocialconcept(this.socialconcept);
        },
        computed: {
            isAdmin() {
                return this.$store.getters['authentication/isAdmin'];
            },
            isLoadingData() {
                return this.isLoading;
            },
        },
        methods: {
            editAction(data) {
                return new Promise(() => {
                    this.isLoading = true;
                    const header = this.authHeader();
                    header['Content-Type'] = 'application/merge-patch+json';
                    let senddata = JSON.parse(JSON.stringify(data));
                    const requestOptions = {
                        method: 'PATCH',
                        headers: header,
                        body: JSON.stringify(senddata)
                    };
                    this.isLoading = true;
                    fetch(process.env.VUE_APP_API_SERVER + `/api/actions/`+data.id, requestOptions)
                        .then(this.handleResponse)
                        .then(response => {
                                this.isLoading = false;
                                this.$store.dispatch('alert/success', 'Spielerschutzmaßnahme "'+response.name+'" (ID: '+response.id+') wurde editiert.');
                                this.editable.splice(this.editable.indexOf(data.id),1)
                            },
                            error => {
                                this.isLoading = false;
                                this.$store.dispatch('alert/error', error);
                            });
                });
            },
            editSocialConceptFunction(data) {
                return new Promise(() => {
                    this.isLoading = true;
                    const header = this.authHeader();
                    header['Content-Type'] = 'application/merge-patch+json';
                    let senddata = JSON.parse(JSON.stringify(data));
                    const requestOptions = {
                        method: 'PATCH',
                        headers: header,
                        body: JSON.stringify(senddata)
                    };
                    this.isLoading = true;
                    fetch(process.env.VUE_APP_API_SERVER + `/api/socialconcepts/`+data.id, requestOptions)
                        .then(this.handleResponse)
                        .then(response => {
                                this.isLoading = false;
                                this.$store.dispatch('alert/success', 'Sozialkonzept "'+response.name+'" (ID: '+response.id+') wurde editiert.');
                            },
                            error => {
                                this.isLoading = false;
                                this.$store.dispatch('alert/error', error);
                            });
                });
            },
            addSocialConceptFunction(data) {
                return new Promise(() => {
                    this.isLoading = true;
                    const header = this.authHeader();
                    header['Content-Type'] = 'application/json';
                    let senddata = JSON.parse(JSON.stringify(data));
                    const requestOptions = {
                        method: 'POST',
                        headers: header,
                        body: JSON.stringify(senddata)
                    };
                    this.isLoading = true;
                    fetch(process.env.VUE_APP_API_SERVER + `/api/socialconcepts`, requestOptions)
                        .then(this.handleResponse)
                        .then(response => {
                                this.isLoading = false;
                                this.$store.dispatch('alert/success', 'Sozialkonzept "'+response.name+'" (ID: '+response.id+') wurde hinzugefügt.');
                                this.loadSocialConcepts();
                                this.socialconcept = response.id;
                                this.changeSocialconcept(response.id);
                            },
                            error => {
                                this.isLoading = false;
                                this.$store.dispatch('alert/error', error);
                            });
                });
            },
            changeSocialconcept(id) {
                if (this.socialconcept === null) {
                    this.tableData = [];
                    return;
                }
                this.isLoading = true;
                this.showEditSocialConcept = false;
                this.showAddSocialConcept = false;
                this.getTableData(id).then(
                    response => {
                        this.tableData = response.member;
                        this.totalitems = response.totalItems;
                        this.isLoading = false;
                    }
                )
            },
            getTableData(id){
                return new Promise((resolve, reject) => {
                    const header = this.authHeader();
                    header['Content-Type'] = 'application/json';
                    const requestOptions = {
                        method: 'GET',
                        headers: header
                    };

                    let url = process.env.VUE_APP_API_SERVER + `/api/actions?pagination=false&socialconcept=` + id;

                    fetch(url, requestOptions)
                        .then(this.handleResponse)
                        .then(response => {
                            resolve({
                                totalItems: response['hydra:totalItems'],
                                member: response['hydra:member']
                            });
                        }, error => {reject(error); });
                });
            },
            loadSocialConcepts() {
                this.isLoading = true;
                this.getSocialConcepts().then(
                    response => {
                        this.socialconceptList= response.member;
                        this.isLoading = false;
                    },
                    error =>{
                        this.$store.dispatch('alert/error',error);
                    }
                )
            },
            getSocialConcepts(){
                return new Promise((resolve, reject) => {
                    const header = this.authHeader();
                    header['Content-Type'] = 'application/json';
                    const requestOptions = {
                        method: 'GET',
                        headers: header
                    };

                    let url = process.env.VUE_APP_API_SERVER + `/api/socialconcepts?pagination=false`;

                    fetch(url, requestOptions)
                        .then(this.handleResponse)
                        .then(response => {
                            resolve({
                                totalItems: response['hydra:totalItems'],
                                member: response['hydra:member']
                            });
                        }, error => {reject(error); });
                });
            }
        }
    }
</script>

<style scoped>
    .form-no-padding {
        padding: 0;
        margin: 0;
    }
    .datepicker-margin {
        margin: 10px;
    }
</style>